module.exports = __webpack_public_path__ + "static/media/comment.383cd664.svg";